(function () {
	'use strict';

	angular.module('mx.SolutionBuilderAgent').component('mxLocalizationEditorForm', {
		bindings: {
			localizedValue: '=',
			supportedLanguages: '<',
			errors: '=?',
			title: '@?',
			prepareProperty: '=?',
			saveLocalizationDirectly: '@',
			richTextMode: '=',
			richTextModeOptions: '=?',
			activeMode: '@',
			customEditor: '<?',
		},
		controller: MxLocalizationEditorFormCtrl,
		controllerAs: 'vm',
		templateUrl: 'workspaces/SolutionBuilderAgent/components/mx-localization-editor/mx-localization-editor-form.html',
	});

	MxLocalizationEditorFormCtrl.$inject = [
		'$q',
		'mx.SolutionBuilderAgent.TranslationService',
		'mx.shell.UserProfileService',
		'mx.shell.Config',
		'mx.internationalization',
		'$scope',
	];

	function MxLocalizationEditorFormCtrl($q, translationService, userProfileService, config, i18n, $scope) {
		var vm = this;

		var originalValueLcid = 9;

		vm.$onInit = function () {
			vm.canSave = true;
			vm.prepareProperty = prepareProperty;
			load();

			$scope.$watch(
				'vm.property.translations',
				function (translations, old) {
					if (translations !== old && vm.originalLang && vm.originalLang.translation && !vm.originalLang.translation.value) {
						populateOriginalValueIfEmpty(translations);
					}
				},
				true
			);
		};

		vm._isEmpty = _isEmpty;

		return vm;

		function load() {
			if (vm.localizedValue.id) {
				$q.all([
					vm.saveLocalizationDirectly === 'true' ? translationService.get(vm.localizedValue.id) : $q.when(vm.localizedValue),
					translationService.getAllLanguages(vm.supportedLanguages ? vm.supportedLanguages : mx.SolutionBuilderAgent.LanguageGroupFilter.UI),
					userProfileService.get(),
				]).then(function (data) {
					if (data[1] && data[2]) {
						prepareData(data[0], data[1], data[2]);
					}
				});
			}
		}

		function populateOriginalValueIfEmpty(translations) {
			var newValue = '';

			translations.some(function (translation) {
				newValue = translation.value || newValue;
				return translation.lcid === vm.currentLanguage.lcid && translation.value;
			});

			if (newValue) {
				vm.originalLang.translation.value = newValue;
			}
		}

		function mapTranslation(language) {
			vm.property.translations.some(function (t) {
				if (t.lcid === (language.isBaseLanguageInGroup ? language.parentLcid : language.lcid)) {
					language.translation = t;
					return true;
				}
			});
		}

		function prepareData(property, languages, profile) {
			vm.canSave = Boolean(property);
			if (!property) {
				vm.errors = [i18n.get('solutionBuilderAgent.components.mx-localization-editor-form.newValue')];
				property = { Id: vm.localizedValue.id };
			}

			var initialized = property instanceof mx.SolutionBuilderAgent.LocalizationProperty;
			vm.property = initialized ? property : new mx.SolutionBuilderAgent.LocalizationProperty(property);

			vm.profile = profile;
			vm.languages = languages;

			vm.languages.forEach(function (lang) {
				if (lang.id.toLowerCase() === vm.profile.languageId.toLowerCase()) {
					lang.__current = true;
					vm.currentLanguage = lang;
				}

				lang.flagSrc = config.settings.imgHosts.flags + lang.flagUrl;
				lang.translation = new mx.SolutionBuilderAgent.LocalizationPropertyTranslation({ Lcid: lang.isBaseLanguageInGroup ? lang.parentLcid : lang.lcid });

				if (lang.lcid === originalValueLcid) {
					vm.originalLang = lang;
				}
			});

			vm.data = {};

			vm.languages
				.sort(function (a, b) {
					return (b.isBaseLanguageInGroup ? 1 : 0) - (a.isBaseLanguageInGroup ? 1 : 0);
				})
				.forEach(function (language) {
					if (language.isBaseLanguageInGroup) {
						language.subLanguages = [];
						vm.data[language.parentLcid] = language;
					} else {
						var baseLanguage;

						if (!vm.data.hasOwnProperty(language.parentLcid)) {
							baseLanguage = {
								__current: false,
								subLanguages: [],
								title: language.parentTitle || i18n.get('solutionBuilderAgent.common.base') + ' ' + language.twoLetterCode.toUpperCase(),
								lcid: language.parentLcid,
								parentLcid: language.parentLcid,
								code: language.twoLetterCode,
								translation: new mx.SolutionBuilderAgent.LocalizationPropertyTranslation({ Lcid: language.parentLcid }),
							};
							vm.data[language.parentLcid] = baseLanguage;
							mapTranslation(baseLanguage);
						} else {
							baseLanguage = vm.data[language.parentLcid];
						}

						baseLanguage.subLanguages.push(language);
						baseLanguage.__current = baseLanguage.__current || language.__current;
					}

					mapTranslation(language);
				});

			vm.langsForTemplate = [];
			for (var baseLcid in vm.data) {
				if (vm.data.hasOwnProperty(baseLcid)) {
					vm.langsForTemplate.push(vm.data[baseLcid]);
				}
			}

			vm.langsForTemplate.sort(function (a, b) {
				return a.__current ? -1 : b.__current ? 1 : a.parentLcid < b.parentLcid ? -1 : 1;
			});
		}

		function translationsContainLcid(translations, lcid) {
			return translations.some(function (t) {
				return t.lcid === lcid;
			});
		}

		function addSubLanguageToTranslations(translations, baseLang) {
			var resTranslations = translations;
			baseLang.subLanguages.forEach(function (lang) {
				resTranslations = resTranslations.filter(function (l) {
					return lang.translation && lang.translation.lcid && l.lcid !== lang.translation.lcid;
				});
				if (!_isEmpty(lang.translation && lang.translation.value)) {
					resTranslations.push(
						new mx.SolutionBuilderAgent.LocalizationPropertyTranslation({
							Lcid: lang.translation.lcid,
							Value: lang.translation.value,
						})
					);
				}
			});
			return resTranslations;
		}

		function prepareProperty(id) {
			if (!vm.canSave || !id) {
				return;
			}

			if (vm.originalLang && vm.originalLang.translation && !vm.originalLang.translation.value) {
				vm.errors = (vm.errors || []).push(i18n.get('solutionBuilderAgent.components.mx-localization-editor-form.emptyOriginal'));
			}

			var property = vm.property;

			property.translations = property.translations.filter(function (l) {
				return !_isEmpty(l.value);
			});

			for (var baseLcid in vm.data) {
				if (vm.data.hasOwnProperty(baseLcid)) {
					var baseLang = vm.data[baseLcid];

					if (!translationsContainLcid(property.translations, baseLang.parentLcid) && !_isEmpty(baseLang.translation.value)) {
						property.translations.push({
							lcid: baseLang.parentLcid,
							value: baseLang.translation.value,
						});
					}
					property.translations = addSubLanguageToTranslations(property.translations, baseLang);
				}
			}
			var baseLcidTranslationIndex = _.findIndex(property.translations, { lcid: originalValueLcid });
			if (baseLcidTranslationIndex >= 0) {
				var baseLangTranslation = property.translations.splice(baseLcidTranslationIndex, 1);
				if (baseLangTranslation.length && baseLangTranslation[0].value !== property.value) {
					property.value = baseLangTranslation[0].value;
				}
			}

			return property;
		}

		function _isEmpty(value) {
			return (
				$('<p>' + (value || '') + '</p>')
					.text()
					.trim() === ''
			);
		}
	}
})();
